import { MeasurementValues } from "@novorender/api";
import { useEffect, useState } from "react";

import { useExplorerGlobals } from "contexts/explorerGlobals";
import { ExtendedMeasureEntity } from "types/misc";

import { useMeasureObjects } from "./useMeasureObjects";

export function useMeasuredObjectData(obj: ExtendedMeasureEntity, idx: number, currentIndex: number) {
    const {
        state: { view },
    } = useExplorerGlobals(true);

    const measureObjects = useMeasureObjects();
    const currentMeasureObject = measureObjects.length > currentIndex ? measureObjects[currentIndex][idx] : undefined;
    const [measureValues, setMeasureValues] = useState<MeasurementValues>();
    const [isGenerated, setIsGenerated] = useState<null | boolean>(null);

    useEffect(() => {
        getMeasureValues();

        async function getMeasureValues() {
            if (currentMeasureObject) {
                setMeasureValues(
                    await view?.measure?.core.measure(currentMeasureObject, undefined, currentMeasureObject.settings),
                );
            } else {
                setMeasureValues(undefined);
            }
        }
    }, [currentMeasureObject, view]);

    useEffect(() => {
        checkIsGenerated();

        async function checkIsGenerated() {
            if (!view) {
                return;
            }

            setIsGenerated(Boolean(await view.measure?.core.isParametricDataGenerated(obj.ObjectId)));
        }
    }, [view, obj]);

    return {
        currentMeasureObject,
        measureValues,
        isGenerated,
    };
}
